function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 12C2 6.478 6.478 2 12 2s10 4.478 10 10-4.478 10-10 10S2 17.522 2 12zm10-5.028c.895 0 1.739.306 2.378.867.665.581 1.031 1.363 1.029 2.2 0 1.232-.812 2.34-2.069 2.824a1.03 1.03 0 00-.658.955v.483a.17.17 0 01-.17.17h-1.024a.17.17 0 01-.17-.17v-.458a2.381 2.381 0 011.534-2.254c.727-.28 1.196-.887 1.196-1.55 0-.939-.919-1.704-2.046-1.704-1.127 0-2.045.765-2.045 1.705v.162a.17.17 0 01-.17.17H8.76a.171.171 0 01-.17-.17v-.162c0-.838.366-1.62 1.031-2.201A3.603 3.603 0 0112 6.972zm-.603 10.318a.852.852 0 111.205-1.205.852.852 0 01-1.205 1.205z"
})));